// ProModeContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

// Create a context to manage the pro mode state globally
const ProModeContext = createContext();

export function ProModeProvider({ children }) {
  // Pro mode is always enabled
  const isProMode = true;

  // Always apply the pro mode class to the body
  useEffect(() => {
    document.body.classList.add('pro-mode');
    return () => {
      // Cleanup if component unmounts (shouldn't happen for provider)
      document.body.classList.remove('pro-mode');
    };
  }, []);

  // Toggle function does nothing since pro mode is always on
  const toggleProMode = () => {
    // No-op: Pro mode is always enabled
  };

  return (
    <ProModeContext.Provider value={{ isProMode, toggleProMode }}>
      {children}
    </ProModeContext.Provider>
  );
}

// Custom hook to use the pro mode context
export function useProMode() {
  const context = useContext(ProModeContext);
  if (!context) {
    throw new Error('useProMode must be used within a ProModeProvider');
  }
  return context;
}

// ProModeToggle component - place this in the navbar or settings
export function ProModeToggle() {
  const { isProMode, toggleProMode } = useProMode();

  return (
    <div className="pro-mode-toggle">
      <label className="toggle-switch">
        <input 
          type="checkbox" 
          checked={isProMode} 
          onChange={toggleProMode} 
        />
        <span className="toggle-slider"></span>
        <span className="toggle-label">{isProMode ? 'PRO' : 'STD'}</span>
      </label>
    </div>
  );
}